import api from 'plugin/api';

/**
 *  보고서 - 월말보고서
 */

/**
 *  @description 월말보고서 목록API
 */
async function monthEndReportList(params) {
  const url = '/sfsh/report/monthEnd';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 월말보고서 등록API
 */
async function monthEndReporCreate(requestBody) {
  const url = '/sfsh/report/monthEnd';

  const response = await api.post(url, requestBody);
  return response;
}

/**
 *  @description 월말보고서 - 상세 API
 */
async function monthEndReporDetail(seq) {
  const url = `/sfsh/report/monthEnd/${seq}`;

  const response = await api.get(url);
  return response;
}

/**
 *  @description 월말보고서 - 수정 API
 */
async function monthEndReporUpdate(seq, requestBody) {
  const url = `/sfsh/report/monthEnd/${seq}`;

  const response = await api.put(url, requestBody);
  return response;
}

/**
 *  @description 월말보고서 통계테이블 생성API
 */
async function statisticsCreate(params) {
  const url = '/sfsh/report/monthEnd/stt';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 월말보고서 통계테이블 업데이트API
 */
async function statisticsUpdate(seq) {
  const url = `/sfsh/report/monthEnd/stt/${seq}`;

  const response = await api.put(url);
  return response;
}

/**
 *  @description 월말보고서 존재여부 확인API
 */
async function monthEndExist(params) {
  const url = '/sfsh/report/monthEnd/exist';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 월말보고서 이력목록API
 */
async function approvalList(seq) {
  const url = `/sfsh/report/monthEnd/${seq}/approval`;

  const response = await api.get(url);
  return response;
}

export {
  monthEndReportList,
  monthEndReporCreate,
  monthEndReporDetail,
  monthEndReporUpdate,
  statisticsCreate,
  statisticsUpdate,
  monthEndExist,
  approvalList
};
